<template>
	<v-container>
		<v-card>
			<v-card-title>
				<h1 class="display-1">Búsqueda de pacientes</h1>
			</v-card-title>
			<v-card-text>
				<v-form v-model="validaFormBusqueda">
					<v-row >
						<v-col cols="10">
							<v-text-field 
								v-model="textoBusqueda" 
								@keydown.enter.prevent=""
								label="Datos de búsqueda (Indique solamente Nombre o Primer Apellido o Segundo Apellido)" 
								prepend-icon="mdi-account-search-outline" 
								:rules="busquedaRules"
							/>
						</v-col>
						<v-col cols="1">
							<v-btn
								color="info"
								@click="buscaPacientes"
								:disabled="!validaFormBusqueda"
							>Buscar</v-btn>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
		</v-card>
		<span v-if="datosLocalizados">
			<v-data-table
				:headers="encabezados"
				:items="pacientes"
				:items-per-page="5"
				class="elevation-3"
				:multi-sort="true"
				@click:row="pacienteSeleccionado"
			>
			</v-data-table>
		</span>
		<span v-if="notasLocalizadas">
			<v-row>
				<v-col cols="12" sm="6">
					<v-text-field label="Paciente" v-model="paciente" readonly></v-text-field>
				</v-col>
				<v-col cols="12" sm="6">
					<v-text-field label="Terapeuta" v-model="terapeuta" readonly></v-text-field>
				</v-col>
			</v-row>
			<v-data-table
				:headers="encCitas"
				:items="listaCitas"
				:items-per-page="9"
				class="elevation-1"
				:multi-sort="true"
				@click:row="citaSeleccionada"
			>
			</v-data-table>
		</span>
		<span v-if="folio!=0">
			<v-row>
				<v-col>
					<NotasDeSesion :datosCita="infoDeCita" @cancela-notas="cancelaNotas"/>
				</v-col>
			</v-row>
		</span>
		<v-snackbar v-model="activarDesactivar">
			{{ mensajeError }}
			<v-btn color="pink" text @click="activarDesactivar = false">Cerrar</v-btn>
		</v-snackbar>
	</v-container>
</template>

<script>
import NotasDeSesion from '@/components/NotasDeSesion'
import ServiciosApi from '@/services/ServiciosApi.js'
export default{
	name: 'Busqueda',
	components: {
		NotasDeSesion,
	},
	data() {
		return {
			encabezados: [
				{text: 'Folio', value: 'idSolicitud' },
				{text: 'Fecha', value: 'fechaSolicitud'},
				{text: 'Paciente', value: 'paciente'},
				{text: 'Terapeuta', value: 'terapeuta'},
			],
			encCitas: [
				{text: 'Folio', value: 'idSesion'},
				{text: 'Fecha', value: 'fecha'},
				{text: 'Hora', value: 'hora'},
				{text: 'Num. Sesión', value: 'sesion'},
			],
			folio:0,
			infoDeCita: {idCita: 0, paciente: '', terapeuta: '', fecha: '', hora: '', numCita: 0},
			textoBusqueda: '',
			validaFormBusqueda: false,
			datosLocalizados: false,
			notasLocalizadas: false,
			idSolicitud: 0,
			paciente: '',
			terapeuta: '', 
			respuesta: {},
			citasLocalizadas: {},
			listaCitas: [],
			pacientes: [],
			mensajeError: '',
			activarDesactivar: false,
			busquedaRules: [
				value => !!value || "Debe especificarse la información a buscar"
			],
		}
	},
	mounted: function (){
		if(!this.$session.exists()){
			this.$router.push('login')
		}
	},
	methods: {
		buscaDatos(datos) {
			//ServiciosApi.buscaNotasDePacientes(this.textoBusqueda)
			ServiciosApi.busquedaNotas(datos)
				.then(response => {
					this.respuesta = response.data
					if(this.respuesta.status === 'ok'){
						//ToDo Crear opciones para búsqueda
						if(this.respuesta.datos){
							if(datos.tipo==='pacientes'){
								this.datosLocalizados = true
								this.pacientes = this.respuesta.datos.pacientes
							} else if(datos.tipo==='notasDeSesion'){
								this.notasLocalizadas = true
								this.listaCitas = this.respuesta.datos.notas
							} else if(datos.tipo==='detalleNotas'){
								this.folio = this.respuesta.datos.notas.idCita
								this.infoDeCita.idCita = this.folio
								this.infoDeCita.paciente = this.paciente
								this.infoDeCita.terapeuta = this.terapeuta
								this.infoDeCita.fecha = datos.fecha
								this.infoDeCita.hora = datos.hora
								this.infoDeCita.numCita = datos.numCita
							}
						} else {
							if(datos.tipo==='pacientes'){
								this.datosLocalizados = false
							} else if (datos.tipo === 'notasDeSesion'){
								this.notasLocalizadas = false
							} else if (datos.tipo === 'detalleNotas'){
								this.folio = 0
							}
							this.activarDesactivar = true
							this.mensajeError = this.respuesta.mensaje
						}
					} else {
						this.mensajeError = this.respuesta.mensaje
						this.activarDesactivar = true
						this.datosLocalizados = false
						this.textoBusqueda = ''
					}
				})
				.catch(error => {
					this.activarDesactivar = true
					this.mensajeError = 'Ocurrió un error en el servidor, intente más tarde"'
					console.log("Hubieron errores", error.response)
				})
		},
		buscaPacientes(){
			let datosDeBusqueda = {
				tipo: 'pacientes',
				valor: this.textoBusqueda
			}
			this.buscaDatos(datosDeBusqueda)
		},
		pacienteSeleccionado(event) {
			//console.log("paciente seleccionado")
			//console.log("Evento:", event)
			//this.idSolicitud = event.idSolicitud
			this.paciente = event.paciente
			this.terapeuta = event.terapeuta
			//console.log("IdSolicitud", this.idSolicitud)
			//console.log("Paciente", this.paciente)
				/*
			ServiciosApi.buscaNotasDeSesion(this.idSolicitud)
				.then(response => {
					this.citasLocalizadas = response.data
					console.log("Informacion devuelta", this.citasLocalizadas)
					if(this.citasLocalizadas.status === 'ok'){
						if(this.citasLocalizadas.datos){
							this.notasLocalizadas = true
							this.listaCitas = this.citasLocalizadas.datos.notas
						} else {
							this.activarDesactivar = true
							this.notasLocalizadas = false
							this.mensajeError = this.citasLocalizadas.mensaje
						}
					} else {
						this.activarDesactivar = true
						this.notasLocalizadas = false
						this.mensajeError = this.citasLocalizadas.mensaje
					}
				})
				 */
			let datosDeBusqueda = {
				tipo: 'notasDeSesion',
				valor: event.idSolicitud//this.idSolicitud
			}
			this.buscaDatos(datosDeBusqueda)
		},
		citaSeleccionada(event){
			console.log("Cita Seleccionada", event)
			let datosDeBusqueda = {
				tipo: 'detalleNotas',
				valor: event.idSesion,
				fecha: event.fecha,
				hora: event.hora,
				numCita: event.sesion
			}
			this.buscaDatos(datosDeBusqueda)
		},
		cancelaNotas() {
			console.log("Entramos a cancela Notas")
			this.folio = 0
		},
	},
}
</script>
